
import React from "react";
import "./deities.css";

// ============================================================
// DEITY DATA
// Replace the URLs below with your actual external web URLs.
// ============================================================

const deities = [
    {
        id: 1,
        name: "Subramanya Swamy",
        regionalName: "സുബ്രഹ്മണ്യ സ്വാമി",
        image: "/images/deities/subramanian.png",
        url: "https://booking.peralasserytemple.in/Default.aspx?i=1",
        description:
            "",
    },
    {
        id: 2,
        name: "Nagam",
        regionalName: "നാഗദേവത",
        image: "/images/deities/nagam.png",
        url: "https://booking.peralasserytemple.in/Default.aspx?i=2",
        description:
           "",
    },
    {
        id: 3,
        name: "Lord Ayyappan",
        regionalName: "ശ്രീ അയ്യപ്പൻ",
        image: "/images/deities/ayyappan.png",
        url: "https://booking.peralasserytemple.in/Default.aspx?i=3",
        description:
           "",
    },
    {
        id: 4,
        name: "Lord Ganapathy",
        regionalName: "ശ്രീ ഗണപതി",
        image: "/images/deities/ganapathy.png",
        url: "https://booking.peralasserytemple.in/Default.aspx?i=4",
        description:
            "",
    },
];

export default function DietyFront() {

    // ============================================================
    // OPEN EXTERNAL PAGE
    // ============================================================

    const openDeityPage = (url) => {
        window.open(
            url,
            "_blank",
            "noopener,noreferrer"
        );
    };

    return (
        <section className="deities-section">

            <div className="deities-container">

                {/* ====================================================
                    SECTION HEADING
                ==================================================== */}

               


                {/* ====================================================
                    DEITY CARDS
                ==================================================== */}

                <div className="deities-grid">

                    {deities.map((deity) => (

                        <article
                            className="deity-card"
                            key={deity.id}
                            onClick={() =>
                                openDeityPage(deity.url)
                            }
                        >

                            {/* Image */}

                            <div className="deity-image-wrapper">

                                <img
                                    src={deity.image}
                                    alt={deity.name}
                                    className="deity-image"
                                />

                                <div className="deity-image-overlay"></div>

                                <div className="deity-symbol">
                                    ॐ
                                </div>

                            </div>


                            {/* Content */}

                            <div className="deity-content">

                                <h3>
                                    {deity.name}
                                </h3>

                                <div className="deity-regional-name">
                                    {deity.regionalName}
                                </div>

                                <div className="deity-divider">
                                    <span></span>
                                    <i></i>
                                    <span></span>
                                </div>

                                {/* <p>
                                    {deity.description}
                                </p> */}

                                <button
                                    type="button"
                                    className="deity-read-more"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openDeityPage(deity.url);
                                    }}
                                >
                                    View Vazhipad List

                                    <span className="deity-arrow">
                                        →
                                    </span>
                                </button>

                            </div>

                        </article>

                    ))}

                </div>

            </div>

        </section>
    );
}